import React, { memo } from 'react';
import { TableCell, TableRow } from '@mui/material';
import PropTypes from 'prop-types';
import { TableControls } from '../../../../BaseEditor';

function Row({
  row, fields, actions, readOnly, active, errors,
}) {
  return (
    <TableRow
      key={row.id}
      onClick={(e) => actions.onActivateRow(e, row.id)}
      selected={active}
      hover
    >
      <TableCell>
        <TableControls.DateInput
          value={row.datefrom}
          onChange={(e, v) => actions.onChange(e, row.id, { datefrom: v })}
          readOnly={fields.datefrom.read_only || readOnly}
          errors={errors && errors.datefrom}
        />
      </TableCell>
      <TableCell>
        <TableControls.Selector
          value={row.tax_group}
          precision={2}
          onChange={(e, v) => actions.onChange(e, row.id, { tax_group: v })}
          readOnly={fields.tax_group.read_only || readOnly}
          values={fields.tax_group.choices}
          errors={errors && errors.tax_group}
        />
      </TableCell>
      <TableCell>
        <TableControls.NumerInput
          value={row.percent}
          precision={2}
          onChange={(e, v) => actions.onChange(e, row.id, { percent: v })}
          readOnly={fields.percent.read_only || readOnly}
          errors={errors && errors.percent}
        />
      </TableCell>
    </TableRow>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.number,
    datefrom: PropTypes.string,
    dateto: PropTypes.string,
    percent: PropTypes.number,
    tax_group: PropTypes.number,
  }).isRequired,
  fields: PropTypes.shape({
    datefrom: PropTypes.shape({ read_only: PropTypes.bool }),
    dateto: PropTypes.shape({ read_only: PropTypes.bool }),
    percent: PropTypes.shape({ read_only: PropTypes.bool }),
    tax_group: PropTypes.shape({
      read_only: PropTypes.bool,
      choices: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.number,
        display_name: PropTypes.string,
      })),
    }),
    comment: PropTypes.shape({ read_only: PropTypes.bool }),
  }).isRequired,
  actions: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    onActivateRow: PropTypes.func.isRequired,
  }).isRequired,
  readOnly: PropTypes.bool,
  active: PropTypes.bool,
  errors: PropTypes.shape({
    datefrom: PropTypes.arrayOf(PropTypes.string),
    percent: PropTypes.arrayOf(PropTypes.string),
    tax_group: PropTypes.arrayOf(PropTypes.string),
  }),
};

Row.defaultProps = {
  readOnly: false,
  active: false,
  errors: null,
};

export default memo(Row);
